import { api } from '@/lib/api';

type Kind = 'photoId' | 'proofAddress' | 'rightToWork' | 'niProof' | 'nameChange';

export const useDocumentUpload = () => {
  const upload = async (kind: Kind, file: File): Promise<string> => {
    const form = new FormData();
    form.append('kind', kind);
    form.append('file', file, file.name);
    const res = await api.post<{ objectKey: string }>('/uploads', form);
    return res.data.objectKey;
  };

  const remove = async (objectKey: string): Promise<void> => {
    await api.delete('/uploads', { params: { objectKey } });
  };

  return { upload, remove };
};
